import type { GetImpactRatingByIdResponseRow } from '@risksmart-app/trpc/src/types';
import type { GetImpactRatingByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetImpactRatingByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetImpactRatingByIdArgs = {
  id: string;
};

export const useGetImpactRatingById = createQueryHook<
  UseGetImpactRatingByIdArgs,
  GetImpactRatingByIdResponseRow[],
  GetImpactRatingByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.impactRating.impactRatingById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ impact_rating: data }),
  graphqlDocument: GetImpactRatingByIdDocument,
  graphqlVariables: ({ id }) => ({ id }),
});
